import { Box, List, ListItem, Stack, Typography } from '@mui/joy'
import { useStoreMap } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { driverModel } from '~/entities/common/Driver'
import {
  getCheckKindLabel,
  getGibddResultsData,
} from '~/entities/common/DriverCheck/lib'
import { GibddResults as GibddResultsType } from '~/shared/api'
import { CheckKindEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'

type GibddResultsProps = {
  results: GibddResultsType
  onClose: () => void
}

export function GibddResults({ results, onClose }: GibddResultsProps) {
  const { t } = useTranslation()

  const drivingExperience = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getFormattedDrivingExperienceDuration(),
  )
  const { drivingCategory, decisions, message } = getGibddResultsData(results)
  const showMessage = !drivingCategory && !decisions.length && message
  return (
    <Stack spacing={2}>
      <Typography fontWeight={600} fontSize={20}>
        {t(getCheckKindLabel(CheckKindEnum.GIBDD))}
      </Typography>
      {Boolean(drivingCategory) && (
        <Typography>
          {t('category')}: <b>{drivingCategory}</b>
        </Typography>
      )}
      {drivingExperience && (
        <Typography>
          {t('experience')}: <b>{drivingExperience}</b>
        </Typography>
      )}
      {decisions.length > 0 && (
        <div>
          <Typography fontWeight={500}>{t('solutions')}</Typography>
          <List>
            {decisions.map(({ comment, isExpired, date, srok }) => (
              <ListItem key={comment} style={{ display: 'block' }}>
                <Box>
                  <Typography>
                    {comment}
                    {isExpired && <span> ({t('expired')})</span>}
                  </Typography>
                </Box>
                <Box>
                  <Typography>
                    {t('date')}: {date}
                  </Typography>
                </Box>
                <Box>
                  <Typography>
                    {t('term')}: {srok}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </div>
      )}
      {showMessage && <Typography>{message}</Typography>}

      <br />
      <Button variant='gray' onClick={onClose}>
        {t('button.close')}
      </Button>
    </Stack>
  )
}
